<script>
  import BasePopupWrapper from '../../../../popups/BasePopupWrapper/BasePopupWrapper.vue'
  import { getSupportedNetworks } from '@/shared/utils/apple-pay'
  const APPLE_PAY_SCRIPT_ID = 'apple-pay-script'
  if (!window.logAppleButton) {
    window.logAppleButton = (info) => {
      const el = document.getElementById('logApple')
      el.insertAdjacentHTML('beforeend', `<li id="two">${info}</li>`)
    }
  }
  export default {
    name: 'QuoteApplePayButton',
    components: {
      BasePopupWrapper,
    },
    props: {
      totalPrice: {
        type: Number,
        default: 0,
      },
      showBtn: {
        type: Boolean,
        default: false,
      },
      quoteNumber: {
        type: [String, Number],
      },
      getTotalCallBack: {
        type: Function,
      },
      acceptance: {
        type: Boolean,
        default: true,
      },
      validateBeforePayment: {
        type: Function,
        default: () => Promise.resolve(true),
      },
    },
    emits: ['succeedPayment', 'startPay'],
    data() {
      return {
        scriptLoaded: false,
        log: [],
        orderid: '',
        disable: false,
        errorPopup: false,
      }
    },
    computed: {
      totalPrice_() {
        return this.totalPrice
      },
      acceptance_() {
        return this.acceptance
      },
      showBtn_() {
        return this.showBtn
      },
    },
    created() {
      // if (window.ApplePaySession) {
      //   this.scriptLoaded = true
      //   return
      // }
      this.loadAppleScript().then(() => {
        this.scriptLoaded = true
      })
    },
    methods: {
      onSubmitApplePay(event) {       
        this.$emit('start-pay')
        if (!this.acceptance_) return
        if (!window.ApplePaySession) {
          return false
        }
        const session = this.createSession()
        if (!session) {
          return false
        }

        const validateBeforePayment = this.validateBeforePayment
        session.orderIdQic = ''
        session.onvalidatemerchant = (event) => {
          validateBeforePayment().then((isValid) => {
            if (!isValid) {
              throw new Error('Validation failed')
            }

            return fetch('/payap?action=getorderid')
          })
            .then((res) => res.json())
            .then((res) => {
              session.orderIdQic = res.orderid
              // logAppleButton(`orderID: ${orederId}`)
              return fetch(
                `/payap?action=getmerchantsession&url=${event.validationURL}&quoteno=${this.quoteNumber}`
              )
            })
            .then((res) => res.json())
            .then((merchantSession) => {
              session.completeMerchantValidation(merchantSession)
            })
            .catch((err) => {
              console.error('Error fetching merchant session', err)
            })
        }
        session.onpaymentmethodselected = (event) => {
          session.completePaymentMethodSelection({
            newTotal: { label: 'QIC Insurance', amount: String(this.totalPrice_), type: 'final' },
          })
        }
        const succeedCallback = this.succeedPayment.bind(this)
        const showErrorPopup = this.showErrorPopup.bind(this)
        session.onpaymentauthorized = (event) => {
          // getTotal()
          //   .then((res) => {
          // logAppleButton(`Total: ${JSON.stringify(res)}`)
          //   return fetch('/payap?action=getorderid')
          // })
          // .then(res => res.json())
          // .then((res) => {
          //    const orederId = res.orderid
          // logAppleButton(`orderID: ${orederId}`)
          const formData = new FormData()
          formData.append('token', JSON.stringify(event.payment.token))
          formData.append('orderid', session.orderIdQic)
          return fetch('/payap?action=paymenttoken', {
            method: 'POST',
            body: formData,
          })
            .then((res) => res.json())
            .then((res) => {
              session.completePayment({ status: res.status })
              // logAppleButton('Success: ' + res.success)
              if (res.success) {
                succeedCallback()
              } else {
                showErrorPopup()
              }
            })
            .catch((err) => {
              console.log(err.message)
              // logAppleButton('Error' + err.message)
            })
        }
        // logAppleButton('Session begin')
        session.begin()
      },
      createSession() {
        const supportedNetworks = getSupportedNetworks()
        const request = {
          countryCode: 'QA',
          currencyCode: 'QAR',
          supportedNetworks,
          merchantCapabilities: ['supports3DS'],
          total: { label: 'QIC Insurance', amount: String(this.totalPrice), type: 'final' },
        }
        return new window.ApplePaySession(3, request)
      },
      loadAppleScript() {
        return new Promise((resolve, reject) => {
          const el = document.getElementById(APPLE_PAY_SCRIPT_ID)

          if (el) {
            return resolve()
          }

          const script = document.createElement('script')
          script.onload = () => {
            resolve()
          }
          script.async = true
          script.id = APPLE_PAY_SCRIPT_ID
          script.src = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js'
          document.head.appendChild(script)
        })
      },
      succeedPayment() {
        this.$emit('succeedPayment')
      },
      showErrorPopup() {
        this.errorPopup = true
        this.$refs.popup.open()
      },
    },
  }
</script>

<template>
  <div v-if="scriptLoaded" class="apple-pay">
    <!--
    	<ul id="logApple">
    	</ul>
    -->
    <!-- <button @click="check">check</button> -->
    <apple-pay-button
      v-show="showBtn_"
      buttonstyle="black"
      type="pay"
      locale="en"
      @click="onSubmitApplePay"
    ></apple-pay-button>
    <BasePopupWrapper v-if="errorPopup" ref="popup" @close="errorPopup = false">
      <div class="warning">
        <div class="titleWarn">
          {{ $t('qic_base_error_heder_line1') }} {{ $t('qic_base_error_heder_line2') }}
        </div>
        <!-- <div class="descWarn">{{ $te(message) ? $t(message) : message }}</div> -->
        <div class="descWarn">Please try another payment method</div>
      </div>
    </BasePopupWrapper>
  </div>
</template>

<style>
  apple-pay-button {
    --apple-pay-button-max-width: 416px;
    --apple-pay-button-width: 100%;
    --apple-pay-button-height: 80px;
    --apple-pay-button-border-radius: 12px;
    --apple-pay-button-padding: 15px 0px;
    --apple-pay-button-box-sizing: border-box;
  }
  .apple-pay-btn {
    --apple-pay-button-min-height: 80px;
  }
  .apple-pay {
    display: grid;
    direction: ltr !important;
  }
  .apple-pay-btn-wrapper .apple-pay-btn,
  .apple-pay-btn-wrapper {
    height: 80px;
    border-radius: 12px;
  }
  .apple-pay-btn-wrapper .apple-pay-btn > span > svg {
    height: 56px;
  }
</style>
